// src/pages/LegalNotice.jsx
// Mentions légales — obligation LCEN art. 6-III-1 (site édité à titre professionnel).
// ⚠️ Toute donnée de cette page est juridique : ne rien y écrire qui ne soit vérifié.
// TVA intracommunautaire : volontairement absente tant qu'elle n'est pas reprise du Kbis.
import React from "react";
import { Link } from "react-router-dom";

export default function LegalNotice() {
  return (
    <div className="bg-white text-black min-h-screen">
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16 text-sm leading-relaxed md:text-base md:leading-relaxed">
        <header className="mb-10">
          <h1 className="text-2xl md:text-3xl font-serif mb-2">Mentions légales</h1>
          <div className="text-gray-500 text-xs md:text-sm">
            Dernière mise à jour : juillet 2026
          </div>
        </header>

        <section className="space-y-8 text-gray-800">
          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Éditeur du site</h2>
            <p>
              Le site <strong>artkiv.com</strong> et ses sous-domaines sont édités par :
            </p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><strong>QUANG&amp;CO</strong> — société à responsabilité limitée (SARL)</li>
              <li>Capital social : 7 622,45 €</li>
              <li>Siège social : 231 rue Saint-Honoré, 75001 Paris, France</li>
              <li>SIREN : 435 386 107</li>
              <li>RCS Paris : 435 386 107</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Directeur de la publication</h2>
            <p>Ngoc Nguyen Quang, gérant de QUANG&amp;CO.</p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Contact</h2>
            <p>
              Pour toute question relative au site ou aux présentes mentions légales :{" "}
              <a href="mailto:support@artkiv.com" className="underline">
                support@artkiv.com
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Hébergement</h2>
            <p>Le site est hébergé par :</p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><strong>HOSTINGER operations, UAB</strong></li>
              <li>Švitrigailos str. 34, Vilnius 03230, Lituanie</li>
              <li>
                <a href="https://www.hostinger.fr" target="_blank" rel="noopener noreferrer" className="underline">
                  www.hostinger.fr
                </a>
              </li>
            </ul>
            <p className="mt-3 text-gray-600">
              Certains traitements de données s'appuient sur des prestataires techniques
              complémentaires. Le détail de ces sous-traitants et des lieux d'hébergement
              des données figure dans notre{" "}
              <Link to="/privacy-policy" className="underline">
                politique de confidentialité
              </Link>.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments composant le site — structure, textes, visuels,
              logos, marques, bases de données et développements logiciels — est protégé
              par le droit de la propriété intellectuelle et demeure la propriété
              exclusive de QUANG&amp;CO ou de ses partenaires.
            </p>
            <p className="mt-3">
              Toute reproduction, représentation, adaptation ou exploitation, totale ou
              partielle, par quelque procédé que ce soit, sans autorisation écrite
              préalable, est interdite et constitue une contrefaçon sanctionnée par les
              articles L.335-2 et suivants du Code de la propriété intellectuelle.
            </p>
            <p className="mt-3">
              Les œuvres d'art, photographies et documents déposés par les utilisateurs
              restent la propriété de leurs titulaires respectifs. Artkiv n'acquiert
              aucun droit de propriété sur les contenus déposés par ses utilisateurs.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Données personnelles</h2>
            <p>
              Le traitement des données personnelles, les finalités poursuivies, les
              durées de conservation ainsi que les modalités d'exercice de vos droits
              (accès, rectification, effacement, opposition, portabilité) sont décrits
              dans notre{" "}
              <Link to="/privacy-policy" className="underline">
                politique de confidentialité
              </Link>.
            </p>
            <p className="mt-3">
              Toute demande relative à vos données peut être adressée à{" "}
              <a href="mailto:support@artkiv.com" className="underline">
                support@artkiv.com
              </a>. Vous disposez également du droit d'introduire une réclamation auprès
              de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="underline">www.cnil.fr</a>).
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Responsabilité</h2>
            <p>
              QUANG&amp;CO s'efforce d'assurer l'exactitude des informations diffusées sur
              le site. Les estimations, analyses et suggestions produites par les outils
              d'intelligence artificielle d'Artkiv sont fournies à titre indicatif : elles
              ne constituent ni une expertise certifiée, ni une attribution formelle, ni
              un conseil juridique, fiscal ou financier.
            </p>
            <p className="mt-3">
              Les décisions relatives à une succession, une donation ou une transmission
              doivent être préparées avec les professionnels compétents, notamment un
              notaire et, le cas échéant, un conseiller fiscal.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Droit applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de
              litige, et à défaut de résolution amiable, compétence est attribuée aux
              tribunaux compétents de Paris, sous réserve des dispositions impératives
              protectrices des consommateurs.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-serif mb-3">Langue faisant foi</h2>
            <p>
              La version française des accords juridiques et des politiques est considérée
              comme la seule version actuelle et valide de ce document. Toute version
              traduite n'est fournie que pour votre commodité, afin de faciliter la lecture
              et la compréhension de la version française. Les versions traduites ne sont
              pas juridiquement contraignantes et ne peuvent remplacer les versions
              françaises. En cas de désaccord ou de conflit, les accords et politiques
              juridiques en langue française prévaudront.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
